import React, { useEffect, useState } from 'react';
import { Link, useForm, usePage } from '@inertiajs/inertia-react';

const Login = (props) => {
    const { csrf_token } = usePage().props;

    const { data, setData, post, processing, errors } = useForm({
        email: '',
        _token: csrf_token,
        password: '',
        remember: false,
    })


    const [visible, setVisible] = useState(false);
    
    function submit(e) {
        e.preventDefault();
        post('/login');
    }

    useEffect(() => {
        // keep modal open if there are errors
        console.log(errors);
        if(Object.keys(errors).length !== 0){
            props.loginHasErrors(true);
        } else {
            props.loginHasErrors(false);
        }
    }, [errors]);

    return (
        <>
            <div className="container bg-neutral" data-theme="jpm">
                <div className="row mt-4">
                    <div className="col-12">
                        <h2 className="text-xl font-bold mb-0">Sign in to unlock all the sermons on demand</h2>
                        
                        <form onSubmit={submit} acceptCharset="UTF-8">
                        
                        <input name="email" type="email" className="mt-4 input input-bordered w-full max-w-sm" value={data.email}  onChange={e => setData('email', e.target.value)} id="email" placeholder="Email Address" />
                        {errors.email && <div className="label-text text-error">{errors.email}</div>}

                        <div tabIndex="0" className="mt-4 flex input input-bordered w-full max-w-sm" id="password-group">
                            <input name="password"
                                   type={visible ? 'text' : 'password'}
                                   className="bg-transparent outline-none w-80"
                                   value={data.password}
                                   onChange={e => setData('password', e.target.value)}
                                   id="password"
                                   placeholder="Password" />
                            <button type='button' className="login__password-toggle" onClick={()=>setVisible((prevState => !prevState))}>
                                {visible &&
                                    <span className="password-visible-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#e5e7eb80" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_11_1235)">
                                            <path d="M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z" fill="#e5e7eb80"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_11_1235">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                }
                                {!visible &&
                                    <span className="password-gone-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#e5e7eb80" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_11_1239)">
                                            <path d="M12 6.50005C14.76 6.50005 17 8.74005 17 11.5001C17 12.0101 16.9 12.5001 16.76 12.9601L19.82 16.0201C21.21 14.7901 22.31 13.2501 23 11.4901C21.27 7.11005 17 4.00005 12 4.00005C10.73 4.00005 9.51 4.20005 8.36 4.57005L10.53 6.74005C11 6.60005 11.49 6.50005 12 6.50005ZM2.71 3.16005C2.32 3.55005 2.32 4.18005 2.71 4.57005L4.68 6.54005C3.06 7.83005 1.77 9.53005 1 11.5001C2.73 15.8901 7 19.0001 12 19.0001C13.52 19.0001 14.97 18.7001 16.31 18.1801L19.03 20.9001C19.42 21.2901 20.05 21.2901 20.44 20.9001C20.83 20.5101 20.83 19.8801 20.44 19.4901L4.13 3.16005C3.74 2.77005 3.1 2.77005 2.71 3.16005ZM12 16.5001C9.24 16.5001 7 14.2601 7 11.5001C7 10.7301 7.18 10.0001 7.49 9.36005L9.06 10.9301C9.03 11.1101 9 11.3001 9 11.5001C9 13.1601 10.34 14.5001 12 14.5001C12.2 14.5001 12.38 14.4701 12.57 14.4301L14.14 16.0001C13.49 16.3201 12.77 16.5001 12 16.5001ZM14.97 11.1701C14.82 9.77005 13.72 8.68005 12.33 8.53005L14.97 11.1701Z" fill="#e5e7eb80"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_11_1239">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                }
                            </button>
                        </div>

                        {errors.password && <div className="label-text text-error">{errors.password}</div>}

                        <div className="form-control mt-2">
                            <label className="label cursor-pointer justify-start">
                                <input type="checkbox" checked={data.remember} onChange={e => setData('remember', e.target.checked)} className="checkbox checkbox-primary" />
                                <span className="label-text pl-3">Remember Me</span> 
                            </label>
                        </div>

                        <button className="btn btn-primary btn-block mt-2 mb-4" type="submit" disabled={processing}><span className="fa fa-lock"></span> Log In</button>
                        
                        </form>

                        <div className="w-full border-b border-solid border-[#7D7D7D] mt-4 mb-4"></div>

                        <h3 className="text-lg font-bold mb-2">New to the ministry?</h3>
                        <p>Sign up to experience JPM On Demand and receive a free gift!</p>
                        <a href="/register?source=plus&new=true" className="btn btn-outline btn-block mt-5">Create Account</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login;
